module.exports = __webpack_public_path__ + "static/img/10.c8ac650.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/sp/10.png
// module id = O1dW
// module chunks = 0